/**
 * @generated SignedSource<<9d6726a97e38a3364d54586cc2deadf3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnswerListItem_FeaturedFreelancer$data = ReadonlyArray<{
  readonly video: {
    readonly " $fragmentSpreads": FragmentRefs<"SampleVideosButton_SampleVideos">;
  } | null | undefined;
  readonly " $fragmentType": "AnswerListItem_FeaturedFreelancer";
}>;
export type AnswerListItem_FeaturedFreelancer$key = ReadonlyArray<{
  readonly " $data"?: AnswerListItem_FeaturedFreelancer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnswerListItem_FeaturedFreelancer">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AnswerListItem_FeaturedFreelancer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Video",
      "kind": "LinkedField",
      "name": "video",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SampleVideosButton_SampleVideos"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4141895701e60f2ba9823bf28e44621e";

export default node;
